<template>
  <div
    v-if="model.linesheet_file"
    class="b1 p-25 line-height-26 bg-light-gray half-width"
  >
    <div
      class="fleft truncate"
      style="width: calc(100% - 50px)"
    >
      {{ model.linesheet_file.name }}
    </div>
    <i @click="model.linesheet_file.name=null"
       class="pointer fright size-28 icon-close"/>
    <div class="clearfix"></div>
  </div>
</template>
<script>
export default {
  name: "file-selected"
};
</script>
